import { HttpParams } from '../types';

import { applyPathParams } from './applyPathParams';
import { objToEncodedURI } from './objToEncodedURI';

type Params = Record<'queryParams' | 'pathParams', HttpParams>;

export const composeUrlWithParams = (url: string) => ({
  pathParams = {},
  queryParams = {},
}: Params) => {
  const urlWithPathParams = applyPathParams(url)(pathParams);
  const encodedURIParams = objToEncodedURI(queryParams);
  const composedUrl = encodedURIParams
    ? [urlWithPathParams, encodedURIParams].join('?')
    : urlWithPathParams;
  return composedUrl;
};
